import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles'
import * as styles from './_AdviserContactDetails.scss'
import { Form } from 'react-bootstrap'
import ContactNumber from './ContactNumber'
import React from 'react';

function renderContactNumber (number, index) {
  return <ContactNumber labelAsHeading number={number} key={index} />
}

const AdviserContactDetails = ({ adviser, ...remainingProps }) => {
  let adviserAddress = ''
  adviserAddress += adviser.buildingDetails ? adviser.buildingDetails + ', ' : ''
  adviserAddress += adviser.streetAddress ? adviser.streetAddress + ', ' : ''
  adviserAddress += adviser.suburb ? adviser.suburb + ', ' : ''
  adviserAddress += adviser.postalCode ? adviser.postalCode + ', ' : ''
  adviserAddress += adviser.city ? adviser.city : ''

  return <div {...remainingProps}>
    <h2 style={{marginBottom: '40px'}}> Adviser details</h2>
    <form>
      <Form.Group>
        <h4 className={styles['adviser-control-label']}>Name</h4>
        <p className={styles['adviser-name']}>{adviser.adviserName}</p>
      </Form.Group>
      {adviser.contactDetails.publicContactEmailAddress && <Form.Group>
        <h4 className={styles['adviser-control-label']}>Email</h4>
        <p className={styles['adviser-email']}>
          <a href={'mailto:' + adviser.contactDetails.publicContactEmailAddress}>{adviser.contactDetails.publicContactEmailAddress}</a>
        </p>
      </Form.Group>}

      {adviser.contactDetails.contactNumbers.map(renderContactNumber)}

      <Form.Group>
        <h4 className={styles['adviser-control-label']}>Address</h4>
        <p className={styles['adviser-address']}>{adviserAddress}</p>
      </Form.Group>
    </form>
  </div>
}

AdviserContactDetails.propTypes = {
  adviser: PropTypes.object
}

export default  (AdviserContactDetails)
